<template>
  <div>
      <form class="modal fade" method="post" id="leaveReview" tabindex="-1">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Leave a Review</h4>
            <button class="close" type="button" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="review-name">Your Name</label>
                  <input class="form-control" type="text" id="review-name" required>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="review-email">Your Email</label>
                  <input class="form-control" type="email" id="review-email" required>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="review-subject">Subject</label>
                  <input class="form-control" type="text" id="review-subject" required>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="review-rating">Rating</label>
                  <select class="form-control" id="review-rating">
                    <option>5 Stars</option>
                    <option>4 Stars</option>
                    <option>3 Stars</option>
                    <option>2 Stars</option>
                    <option>1 Star</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label for="review-message">Review</label>
              <textarea class="form-control" id="review-message" rows="8" required></textarea>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" type="submit">Submit Review</button>
          </div>
        </div>
      </div>
      </form>
 <!-- Page Content-->
    <div class="bg-secondary pb-4 padding-top-3x mt-30">
      <div class="container">
        <div class="row">
          <!-- Product Gallery-->
          <div class="col-md-6 mb-30">
            <div class="product-gallery"><span v-if="product.sales" class="product-badge text-danger">
              {{product.discount}}</span>
              <!--<img :src="product.img" alt="Product">-->
              <v-zoom :img="product.img" :width="555" :magnify="1"></v-zoom>
             <!-- <div class="product-carousel owl-carousel gallery-wrapper">
                <div class="gallery-item" data-hash="one">
                  <a :href="product.img" data-size="555x480"></a>
                  <v-zoom :img="product.img" :width="555"></v-zoom>
                </div>
              </div>
              -->
            </div>
          </div>
          <!-- Product Info-->
          <div class="col-md-6 mb-30">
            <div class="card border-default bg-white pt-2 box-shadow">
              <div class="card-body">
                <h2 class="mb-3"><strong>{{product.name}}</strong></h2>
                <h3 class="text-normal"><strong>{{product.price}} DA</strong></h3>
                <p class="text-sm text-muted"><strong>{{product.description}}</strong></p>

                <div class="row align-items-end mb-4">
                  <div class="col-sd-4">
                    <div class="form-group mb-0">
                      <p class="text-normal"><strong>&nbsp; &nbsp;   Garantie : 24 mois &nbsp; &nbsp;</strong></p>
                       <p class="text-normal"><strong>&nbsp; &nbsp;   Service aprés vente&nbsp; &nbsp; </strong></p>
                       <p class="text-normal"><strong> &nbsp; &nbsp; Livraison gratuite &nbsp; &nbsp; </strong></p>
                       <br>
                    </div>
                  </div>
                  <div class="accordion" id="accordion1" role="tablist">

            </div>
                  <div class="col-sm-8">
                    <div class="pt-4 hidden-sm-up"></div>
                    <button class="btn btn-primary btn-block my-0" @click="addToCart(product)">Ajouter au panier</button>
                  </div>
                </div>
                <ul class="list-unstyled text-sm mb-4">
                  <li><span class='text-dark text-medium'>Reférence:</span> {{product.id}}</li>
                  <li><span class='text-dark text-medium'>Categories:</span>
                  <a href='#' class='navi-link'>Montre</a>
                  <a href='#' class='navi-link'>{{product.name}}</a>
                  </li>
                </ul>
                <div class="d-flex flex-wrap justify-content-between align-items-center">

                  <div class="py-2">
                    <a class="social-button shape-rounded sb-facebook" href="#" data-toggle="tooltip"
                    data-placement="top" title="Facebook">
                    <i class="socicon-facebook"></i></a>
                    <a class="social-button shape-rounded sb-twitter" href="#" data-toggle="tooltip"
                    data-placement="top" title="Twitter"><i class="socicon-twitter"></i></a>
                    <a class="social-button shape-rounded sb-instagram" href="#"
                    data-toggle="tooltip"
                    data-placement="top" title="Instagram"><i class="socicon-instagram"></i></a>
                    <a class="social-button shape-rounded sb-google-plus" href="#"
                    data-toggle="tooltip" data-placement="top" title="Google +"><i class="socicon-googleplus"></i></a></div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container padding-bottom-3x pt-5 mb-1">
      <!-- Details-->
      <!--<div class="d-flex flex-row pt-2">
        <div class="col-md-6">
          <h3>Details</h3>
          <p class="text-sm mb-4">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>
          <h3>Features</h3>
          <ul class="text-sm mb-4">
            <li>Sed ut perspiciatis unde omnis iste natus error sit voluptatem</li>
            <li>Ut enim ad minima veniam, quis nostrum exercitationem</li>
            <li>Nor again is there anyone who loves or pursues</li>
            <li>At vero eos et accusamus et iusto odio dignissimos ducimus</li>
            <li>Nam libero tempore, cum soluta nobis est eligendi </li>
          </ul>
        </div>
        -->
        <!--<div class="col-md-6">
          <h3>Specifications</h3>
          <ul class="list-unstyled text-sm mb-4">
            <li><strong>Weight:</strong> 6.25 kg</li>
            <li><strong>Dimensions:</strong> 120 x 75 x 90 cm</li>
            <li><strong>Materials:</strong> 40% steel, 37% wood, 23% plastic</li>
            <li><strong>Colors:</strong> White, Gray, Aqua, Charcoal, Orange, Navy, Yellow</li>
            <li><strong>Manufacturer:</strong> Poppin, NY, USA</li>
          </ul>
          <h3>Shipping Options:</h3>
          <ul class="list-unstyled text-sm mb-4">
            <li><strong>Courier:</strong> 2 - 4 days, $22.50</li>
            <li><strong>Local Shipping:</strong> up to one week, $10.00</li>
            <li><strong>UPS Ground Shipping:</strong> 4 - 6 days, $18.00</li>
            <li><strong>Unishop Global Export:</strong> 3 - 4 days, $25.00</li>
          </ul>
        </div>
      </div>
      -->

    </div>
  </div>
</template>

<script>
//vuex mapgetters and mapactions
import { mapGetters, mapActions } from 'vuex';
//vue zoom
import vZoom from 'vue-zoom';

export default {
  components: {
    vZoom
  },
  computed: mapGetters({
    product: 'detailProduct', //<=>this.$store.getters.detailProducts
    images: 'allImages'

  }),
  methods: mapActions(['addToCart'])
};
</script>

<style scoped>
.gallery-item {
  border-radius: 5px;
}

.zoom img {
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/product.vue